import { useMemo, useCallback, useState } from 'react';
import { useGlobal } from 'reactn';
import { isPermitted } from '../../../../../components/permission-control/permission-control';

/**
 * Hook to manage admin-learner messaging modal visibility
 * Checks if user has permission to create conversations for another admin
 * @param {Function} onCloseNewMessageModal - Callback to close the NewMessageModal when opening AdminLearnerModal
 * @returns {Object} Object containing canShowAdminLearnerLink, showAdminLearnerModal, handleOpenAdminLearnerModal, handleCloseAdminLearnerModal
 */
export const useAdminLearnerMessagingHook = (onCloseNewMessageModal) => {
  const [global] = useGlobal();
  const [showAdminLearnerModal, setShowAdminLearnerModal] = useState(false);

  // Check if user has permission to create conversation for another admin
  const canShowAdminLearnerLink = useMemo(() => {
    const { cbacConfigFlag, permissions, permissionIds } = global;
    
    // Check permission using isPermitted function
    // Note: Permission name must match exactly as stored in database (case-sensitive)
    return isPermitted(
      cbacConfigFlag,
      permissions,
      'Feed_Can_Create_Conversation_For_Another_Admin',
      permissionIds
    );
  }, [global.cbacConfigFlag, global.permissions, global.permissionIds]);

  // Handle opening admin-learner modal
  const handleOpenAdminLearnerModal = useCallback(() => {
    // Close the NewMessageModal first if callback is provided
    if (onCloseNewMessageModal) {
      onCloseNewMessageModal();
    }
    // Then open the AdminLearnerModal
    setShowAdminLearnerModal(true);
  }, [onCloseNewMessageModal]);

  // Handle closing admin-learner modal
  const handleCloseAdminLearnerModal = useCallback(() => {
    setShowAdminLearnerModal(false);
  }, []);

  return {
    canShowAdminLearnerLink,
    showAdminLearnerModal,
    handleOpenAdminLearnerModal,
    handleCloseAdminLearnerModal,
  };
};
